import { render } from "./InvoiceRowForm.vue?vue&type=template&id=0b7ef48f&scoped=true"
import script from "./InvoiceRowForm.vue?vue&type=script&lang=js"
export * from "./InvoiceRowForm.vue?vue&type=script&lang=js"

import "./InvoiceRowForm.vue?vue&type=style&index=0&id=0b7ef48f&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7ef48f"]])

export default __exports__